import React, { useState } from 'react';
import { useForm } from '../context/FormContext';
import { YES_NO_QUESTIONS } from './yesNoConfig';
import { US_STATES } from '../utils/states';

export default function StepYesNo({ questionIndex, onNext, onBack }) {
  const { state, dispatch } = useForm();
  const [errs, setErrs] = useState({});
  const q = YES_NO_QUESTIONS[questionIndex];
  const yn = state.yesNo[q.key];

  const setAnswer = (val) => {
    dispatch({ type: 'SET_YESNO', key: q.key, value: { answer: val } });
    setErrs({});
  };

  const setField = (field, val) => {
    dispatch({ type: 'SET_YESNO', key: q.key, value: { [field]: val } });
    setErrs(e => ({ ...e, [field]: '' }));
  };

  const next = () => {
    const e = {};
    if (!yn.answer) { e.answer = 'Please select Yes or No'; setErrs(e); return; }
    if (yn.answer === 'yes') {
      if (q.requiresExplanation && !yn.explanation?.trim()) {
        e.explanation = 'Explanation is required'; setErrs(e); return;
      }
      if (q.specialType === 'other_state_license') {
        if (!yn.previousState) e.previousState = 'State required';
        if (!yn.previousLicenseNumber?.trim()) e.previousLicenseNumber = 'License number required (enter "Unknown" if not known)';
        if (Object.keys(e).length) { setErrs(e); return; }
      }
    }
    onNext();
  };

  return (
    <div className="step-card">
      <h2 className="step-title">Background Questions</h2>
      <p style={{ fontSize: 17, fontWeight: 600, lineHeight: 1.5, marginBottom: 20, color: 'var(--text)' }}>
        {q.question}
      </p>

      <div className="yn-buttons">
        <button className={`yn-btn yes ${yn.answer === 'yes' ? 'selected' : ''}`} onClick={() => setAnswer('yes')}>YES</button>
        <button className={`yn-btn no ${yn.answer === 'no' ? 'selected' : ''}`} onClick={() => setAnswer('no')}>NO</button>
      </div>
      {errs.answer && <div className="field-error" style={{ marginTop: -8, marginBottom: 12 }}>{errs.answer}</div>}

      {yn.answer === 'yes' && q.requiresExplanation && (
        <div className="field-group">
          <label className="field-label">Please explain <span className="required">*</span></label>
          <textarea className={`field-textarea ${errs.explanation ? 'error' : ''}`}
            value={yn.explanation || ''}
            onChange={e => setField('explanation', e.target.value)}
            placeholder="Provide details here..." />
          {errs.explanation && <div className="field-error">{errs.explanation}</div>}
        </div>
      )}

      {yn.answer === 'yes' && q.specialType === 'other_state_license' && (
        <>
          <div className="field-group">
            <label className="field-label">Previous State <span className="required">*</span></label>
            <select className={`field-select ${errs.previousState ? 'error' : ''}`}
              value={yn.previousState || ''}
              onChange={e => setField('previousState', e.target.value)}>
              <option value="">Select state...</option>
              {US_STATES.map(s => <option key={s.code} value={s.code}>{s.code} — {s.name}</option>)}
            </select>
            {errs.previousState && <div className="field-error">{errs.previousState}</div>}
          </div>
          <div className="field-group">
            <label className="field-label">License Number from That State <span className="required">*</span></label>
            <input className={`field-input ${errs.previousLicenseNumber ? 'error' : ''}`}
              value={yn.previousLicenseNumber || ''}
              onChange={e => setField('previousLicenseNumber', e.target.value)}
              placeholder='Enter license number or "Unknown"' />
            {errs.previousLicenseNumber && <div className="field-error">{errs.previousLicenseNumber}</div>}
          </div>
        </>
      )}

      <div className="wizard-nav" style={{ position: 'static', borderTop: 'none', padding: 0, marginTop: 24 }}>
        <button className="btn-back" onClick={onBack}>← Back</button>
        <button className="btn-next" onClick={next}>Next →</button>
      </div>
    </div>
  );
}
